import React from "react";
import {
  Users,
  ShieldCheck,
  Truck,
  Headset,
  BadgeCheck,
  FileBadge,
  BadgePercent,
} from "lucide-react";

const iconMap = {
  Users,
  ShieldCheck,
  Truck,
  Headset,
  BadgeCheck,
  FileBadge,
  BadgePercent,
};

const TrustStrip = ({ items, cols = 4 }) => {
  const gridCols =
    cols === 5
      ? "grid-cols-2 sm:grid-cols-3 lg:grid-cols-5"
      : "grid-cols-2 lg:grid-cols-4";
  return (
    <div className="bg-[#eaf7ee] border-t border-green-100 mt-8">
      <div className={`max-w-[1400px] mx-auto px-4 py-5 grid ${gridCols} gap-5`}>
        {items.map((item) => {
          const Icon = iconMap[item.icon] || ShieldCheck;
          return (
            <div key={item.title} className="flex items-center gap-3">
              <Icon size={30} className="text-[#12a150] shrink-0" strokeWidth={1.7} />
              <div>
                <div className="text-[12.5px] font-bold text-gray-800 leading-tight">
                  {item.title}
                </div>
                <div className="text-[10.5px] text-gray-500 mt-0.5">{item.sub}</div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default TrustStrip;
